import { getQuery } from '@/helpers/hasQuery'
import {
  NotificationType,
  useNotificationStore
} from '@/store/notificationStore'

export const useRouteQueryNotification = () => {
  const message = getQuery('message')
  const errorMessage = getQuery('error_message')

  onMounted(() => {
    const notificationStore = useNotificationStore()
    if (message) {
      notificationStore.showNotification(message, NotificationType.Success)
      return
    }

    if (errorMessage) {
      notificationStore.showNotification(errorMessage, NotificationType.Error)
    }
  })

  return {
    message,
    errorMessage
  } as {
    message: string
    errorMessage: string
  }
}
